// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.

document.addEventListener('DOMContentLoaded', function() {
    const toggleButton = document.getElementById('ajc-toggle-sidenavbar');
    const sidenavbar = document.getElementById('ajc-sidenavbar');
    
    toggleButton.addEventListener('click', function(event) {
        toggleButton.classList.toggle('active');
        sidenavbar.classList.toggle('active');
        
        event.stopPropagation();
    });

    document.addEventListener('click', function(event) {
        if (sidenavbar.classList.contains('active') && !sidenavbar.contains(event.target)) {
            sidenavbar.classList.remove('active');
            toggleButton.classList.remove('active');
        }
    });

    sidenavbar.addEventListener('click', function(event) {
        event.stopPropagation();
    });
});


document.addEventListener('DOMContentLoaded', function() {
    const toggleButtonPrincipal = document.getElementById('ajc-toggle-principal');
    const principal = document.getElementById('ajc-principal');
    const principalParent = document.querySelector('.block--ajc-principal');
    const header = document.querySelector('.page__header');
    
    toggleButtonPrincipal.addEventListener('click', function(event) {
        toggleButtonPrincipal.classList.toggle('active');
        principal.classList.toggle('active');
        principalParent.classList.toggle('active');
        header.classList.toggle('active');
        
        event.stopPropagation();
    });

    document.addEventListener('click', function(event) {
        if (principal.classList.contains('active') && !principal.contains(event.target)) {
            principal.classList.remove('active');
            toggleButtonPrincipal.classList.remove('active');
            principalParent.classList.remove('active');
            header.classList.remove('active');
        }
    });

    principal.addEventListener('click', function(event) {
        event.stopPropagation();
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const principal = document.getElementById('ajc-principal');
    const principalParent = document.querySelector('.block--ajc-principal');
    const level1Elements = document.querySelectorAll('.level-1');
    const header = document.querySelector('.page__header');

    for (let i = 0; i < level1Elements.length; i++) {
        level1Elements[i].addEventListener('mouseenter', function() {
            principal.classList.add('active');
            principalParent.classList.add('active');
            header.classList.add('active');
        });

        // level1Elements[i].addEventListener('mouseleave', function() {
        //     principal.classList.remove('active');
        //     principalParent.classList.remove('active');
        // });
    }
});
document.addEventListener('DOMContentLoaded', function() {
    const principal = document.getElementById('ajc-principal');
    const principalParent = document.querySelector('.block--ajc-principal');
    const header = document.querySelector('.page__header');
    
    principalParent.addEventListener('mouseleave', function() {
        principal.classList.remove('active');
        principalParent.classList.remove('active');
        header.classList.remove('active');
    });
    
});

document.addEventListener('DOMContentLoaded', function() {
window.addEventListener('scroll', function() {
    const scrollHeight = document.documentElement.scrollHeight;
    
    const clientHeight = document.documentElement.clientHeight;
    
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
  
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
  
    if (scrollPercentage > 15) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  });
});  